<div class="app">
    <div class="app-header">
        <app-page-header subtitle="Rapporten"> </app-page-header>
    </div>

    <div class="chat-container">
        <div class="sidebar">
            <div class="sidebar-header">
                <h3 class="sidebar-title">Rapportages</h3>
                <button class="new-chat-btn" (click)="selectEmptyChat()" title="Nieuw gesprek">
                    <i class="fas fa-plus"></i>
                </button>
            </div>
            <ul class="chat-list">
                @for (chat of chatList; track chat) {
                    <li
                        class="chat-item"
                        [class.active]="chat.id === activeChatId"
                        [cdkContextMenuTriggerFor]="chatContextMenu"
                        [cdkContextMenuTriggerData]="{ chat: chat }"
                        (click)="selectChat(chat.id)">
                        <div class="chat-time" [class.validated]="chat.validated" [class.shared]="chat.shared">
                            {{ chat.latest_update || chat.created_at | relativeTime }}
                        </div>
                        <div class="chat-title">{{ chat.title }}</div>
                    </li>
                }
            </ul>
        </div>

        <div class="chat">
            @if (messages.length === 0) {
                <div class="chat-info">
                    <p>Er zijn nog geen berichten in dit gesprek. Typ een bericht om te beginnen.</p>
                </div>
            } @else {
                @if ((chatList | byId: activeChatId)?.validated) {
                    <div class="chat-info">
                        <p>
                            <i class="fa-solid fa-badge-check"></i>
                            Dit is een gevalideerd rapport. Pas filtering op bijvoorbeeld datums en projecten aan. Als
                            je een vrij rapport wilt maken, start dan een nieuwe rapportage.
                        </p>
                    </div>
                }
                <virtual-scroller class="messages" #scroll [items]="messages" [enableUnequalChildrenSizes]="true">
                    @for (message of scroll.viewPortItems; track message) {
                        <app-ai-message
                            [message]="message"
                            [users]="availableUsers"
                            [roles]="availableRoles"
                            (projectClicked)="onProjectClicked($event)"
                            (loadMoreResults)="loadMoreResults($event)"></app-ai-message>
                    }
                </virtual-scroller>
            }
            <form class="composer" (submit)="onSend(msg.value); msg.value = ''; $event.preventDefault()">
                <div class="container-fluid py-2">
                    <div class="input-group position-relative">
                        <app-user-mention
                            #userMention
                            [users]="availableUsers"
                            [roles]="availableRoles"
                            [query]="mentionQuery"
                            [showDropdown]="showMentionDropdown"
                            (itemSelected)="onItemMentioned($event)">
                        </app-user-mention>
                        <input
                            class="form-control"
                            #msg
                            (input)="onInputChange($event)"
                            (keydown)="onKeyDown($event)"
                            type="text"
                            placeholder="Typ een bericht… (gebruik @ om gebruikers en rollen te taggen)"
                            autocomplete="off" />
                        <button class="btn btn-primary" type="submit">Versturen</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<ng-template #chatContextMenu let-chat="chat">
    <div class="chat-context-menu" cdkMenu>
        @if (chat.validated) {
            <button class="context-menu-item" (cdkMenuItemTriggered)="clearChat(chat)" cdkMenuItem>
                <i class="fas fa-broom-wide"></i>
                <span>Chat opschonen</span>
            </button>
        }
        <button class="context-menu-item" (cdkMenuItemTriggered)="exportChat(chat)" cdkMenuItem>
            <i class="fas fa-download"></i>
            <span>Exporteren</span>
        </button>
        <button class="context-menu-item delete-item" (cdkMenuItemTriggered)="deleteChat(chat)" cdkMenuItem>
            <i class="fas fa-trash"></i>
            <span>Verwijderen</span>
        </button>
    </div>
</ng-template>
